import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from '@emotion/styled'
import Layout from 'antd/lib/layout'
import Menu from 'antd/lib/menu'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'

import Route from '../../router'

const { Content, Footer } = Layout
export const LayoutWeb = (props) => {
  const history = useHistory()
  const [current, setCurrent] = useState('HOME')

  const handleClick = (e) => {
    setCurrent(e.key)

    if (e.key === 'HOME') {
      console.log('home')
      history.push('/')
      return null
    }
  }

  return (
    <LayoutStyle>
      <div className='header-web'>
        <div className='layout-header-logo' onClick={() => history.push('/')}>
          <img src='/finnovo_logo_final.png' alt='logo' id='logo' />
        </div>
        <Menu onClick={handleClick} selectedKeys={[current]} mode='horizontal'>
          <Menu.Item key='HOME'>HOME</Menu.Item>
          {/* <Menu.Item key='SOLUTIONS' disabled >
          SOLUTIONS
        </Menu.Item>
        <Menu.Item key='INDUSTRY' disabled>
          INDUSTRY
        </Menu.Item>
        <Menu.Item key='TECHNOLOGY' disabled>
          TECHNOLOGY
        </Menu.Item>
        <Menu.Item key='ABOUT' disabled>
          ABOUT US
        </Menu.Item>
        <Menu.Item key='CONTACT' disabled>
          CONTACT US
        </Menu.Item> */}
        </Menu>
      </div>

      {/* <Layout> */}
      <Content className='content-web'>
        {/* {renderMenu()}
        <Layout className='layout-content'> */}
        <Route />
        {/* </Layout> */}

        <div className='abstract'>
          <Row>
            <Col sm={24} md={24} lg={12} xl={12}>
              <img alt='' src='/finnovo/finnovo_logo_final.png' className='abstract-logo' />
              {/* <div className='abstract-detail'>
                3 Promphan 3 Building, Room 1707-1708, 17th Floor, Soi Ladprao 3, Chomphon,
                Chatuchak, Bangkok 10900 Thailand
                <br />
                <br />
                Email: info@finnovo.co <br />
                Phone: +669 0989 6177
              </div> */}
            </Col>
            <Col sm={24} md={24} lg={6} xl={6}>
              <div className='abstract-label'>Company</div>
              <div className='abstract-detail-list'>
                <div>
                  <span onClick={() => history.push('/')}>Home</span>
                </div>
                {/* <div>Solutions</div>
                <div>Industry</div>
                <div>Technology</div> */}
                <div>
                  <span>About Us</span>
                </div>
                <div>
                  <span>Contact Us</span>
                </div>
              </div>
            </Col>
            <Col sm={24} md={24} lg={6} xl={6}>
              <div className='abstract-label'>Solution</div>
              <div className='abstract-detail-list'>
                <div>
                  <span onClick={() => history.push('/los')}>Loan Origination System</span>
                </div>
                <div>
                  <span onClick={() => history.push('/lms')}>Loan Management System</span>
                </div>
                <div>
                  <span>Card Management System</span>
                </div>
                <div>
                  <span>Collection System</span>
                </div>
                {/* <div>Card Management System</div>
                <div>Collection System</div> */}
              </div>
            </Col>
          </Row>
        </div>
        <Footer className='footer-web'>
          <div className='footer-web-content'>Copyright © 2021 FINNOVO</div>
        </Footer>
      </Content>

      {/* </Layout> */}
    </LayoutStyle>
  )
}

const LayoutStyle = styled(Layout)`
  height: 100vh;
  .header-web {
    @media only screen and (max-width: 700px) {
      padding: 0px 20px;
    }
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    position: fixed;
    z-index: 3;
    width: 100%;
    padding: 0px 40px;
    height: 55px;
    max-height: 55px;
    display: flex;
    justify-content: space-between;
    .layout-header-logo {
      @media only screen and (max-width: 700px) {
        padding-top: 13px;
      }
      cursor: pointer;
      padding-top: 8px;
      img {
        @media only screen and (max-width: 700px) {
          width: 100px;
        }
        width: 150px;
      }
    }
    .ant-menu-horizontal {
      border-bottom: none;
    }
    .ant-menu-item {
      border-bottom: none !important;
    }
  }
  .content-web {
    background-color: #ffffff;
    width: 100%;
    margin-top: 55px;
    padding: 0;
    min-height: calc(100vh - 127px);
  }

  .abstract {
    padding: 40px 60px;
    background-color: #fafafa;
    .abstract-logo {
      @media only screen and (max-width: 700px) {
        width: 133px;
        margin-bottom: -10px;
      }
      width: 170px;
    }
    .abstract-label {
      color: #1564c0;
      font-size: 34px;
      font-weight: bold;
    }
    .abstract-detail {
      @media only screen and (max-width: 700px) {
        font: normal normal normal 12px/30px PoppinsRegular;
      }
      width: 80%;
      font: normal normal normal 14px/30px PoppinsRegular;
      margin: 10px 0 20px;
    }
    .abstract-detail-list {
      @media only screen and (max-width: 700px) {
        font: normal normal normal 12px/30px PoppinsRegular;
      }
      font: normal normal normal 14px/30px PoppinsRegular;
      div {
        span {
          cursor: pointer;
        }

        span:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .footer-web {
    background-color: #fafafa;
    padding: 0 50px 24px;
    .footer-web-content {
      padding: 24px 0 0;
      height: 100%;
      border-top: solid 2px #00000029;
      text-align: center;
    }
  }
`

export default LayoutWeb
